import { v4 as uuidv4 } from 'uuid';
import React, { useState, useEffect, useCallback } from 'react';
import { useRecoilState, useRecoilValue } from 'recoil';
import { useHistory } from 'react-router-dom';
import {
  TableContainer,
  Table,
  TableBody,
  Paper,
  FormControl,
  RadioGroup,
  FormControlLabel,
  Switch,
  Radio,
  Button,
  useMediaQuery,
  Checkbox
} from '@material-ui/core';
import { OtherDocumentCreationButtons } from './OtherDocumentCreationButtons';
import { EstimateItemRow } from './EstimateItemRow';
import EstimateItemsUnderButton from './EstimateItemsUnderButton';
import { AddUnderLayerButton } from './allViewMode/AddUnderLayerButton';
import { LayerModeTableHead } from './layerViewMode/TablaHead';
import { AllViewModeTableHead } from './allViewMode/TableHead';
import { AllViewModeBreadcrumbs } from './allViewMode/Breadcrumbs';
import {
  DragDropContext,
  Draggable,
  Droppable,
  DroppableProvided
} from 'react-beautiful-dnd';
import LibraryAddIcon from '@material-ui/icons/LibraryAdd';
import NavigateNextIcon from '@material-ui/icons/NavigateNext';
import { TTenant } from '../../types/common';
import {
  TEstimateItem,
  TUpdateEstimateItemList,
  TDeleteEstimateItem,
  TSetUniformGrossProfitMargin,
  TAiAverageItem,
  TViewMode,
  CopyModalState,
  CopyModalAction,
  TSaveConfirmModalState
} from '../../types/estimate/estimate';
import {
  userIdState,
  isLoggedIn,
  userTenant,
  btnColor,
  mainBlueColor
} from '../../GlobalState';
import { registerquotation } from '../../apicalls/estimates';
import { getUnitMasterList } from '../../apicalls/unitMaster';
import { getAiEstimatePriceAverage } from '../../apicalls/getAiEstimate';
import {
  createDefaultEstimateItems,
  getEstimateItemByIndexes,
  getChildrenByIndexes,
  getEstimateItemsByIndexes,
  reorder,
  updateCopyItemIds,
  updateEstimateItemLayer
} from '../../utils/estimate';
import {
  setGrossProfitMarginTo100,
  updateParentsNumericalValues,
  updateSellingPricesFromGrossProfitMargin,
  calcAllSellingPrice,
  calcAllCostPrice,
  calcGrossProfit,
  calcGrossProfitMargin
} from '../../utils/calcRules';
import { TSetLocalStorage } from '../../pages/EditEstimates';
import {
  ESTIMATE_DEFAULT_ITEM_COUNT,
  ESTIMATE_SUB_ITEM_MAX,
  ESTIMATE_TOTAL_ITEM_MAX,
  ESTIMATE_ITEM_MAX,
  ESTIMATE_ALLVIEW_MODE_ITEM_MAX
} from '../../const/Const';
import { useStyles } from './Style';
import { on } from 'events';

type EstimateInfo = {
  constructId: number;
  createUserId: number;
  salesUserId: number;
  clientName: string;
  clientChargeName: string;
};

type TProps = {
  estimateItemList: TEstimateItem[];
  setEstimateItemList: React.Dispatch<React.SetStateAction<TEstimateItem[]>>;
  estimateInfo: EstimateInfo;
  viewMode: TViewMode;
  setViewMode: React.Dispatch<React.SetStateAction<TViewMode>>;
  setProgressFlg: React.Dispatch<React.SetStateAction<boolean>>;
  setCustomFormatOverLayerFlg: React.Dispatch<React.SetStateAction<boolean>>;
  setChangeModeAlertModal: React.Dispatch<React.SetStateAction<boolean>>;
  setSaveConfirmModalState: React.Dispatch<
    React.SetStateAction<TSaveConfirmModalState>
  >;
  itemTotalCount: number;
  setItemTotalCount: React.Dispatch<React.SetStateAction<number>>;
  setOpenImportEstimateMasterModal: React.Dispatch<
    React.SetStateAction<boolean>
  >;
  setCopyItem: React.Dispatch<React.SetStateAction<TEstimateItem | undefined>>;
  copyModalState: CopyModalState;
  copyModalDispatch: React.Dispatch<CopyModalAction>;
  setLocalStorage: TSetLocalStorage;
  handleError: (message: string) => void;
  handleSuccess: (message: string) => void;
  displayItemNumber: boolean;
  handleDisplayItemNumberChange: (
    event: React.ChangeEvent<HTMLInputElement>
  ) => void;
  redirectToOtherDocuments: (callback: (estimateId: number) => void) => void;
};

// 別書類作成用に選択される項目の型
// TODO: 挿入順を保持するためにMapを使用する
type TSelectedForOtherDocuments = { [key: string]: TSelectedForOtherDocuments };

const EstimateItems = (props: TProps) => {
  const {
    estimateItemList,
    setEstimateItemList,
    estimateInfo,
    handleError,
    handleSuccess,
    setProgressFlg,
    setLocalStorage,
    copyModalState,
    copyModalDispatch,
    setCustomFormatOverLayerFlg,
    setChangeModeAlertModal,
    setSaveConfirmModalState,
    itemTotalCount,
    setItemTotalCount,
    viewMode,
    setViewMode,
    setOpenImportEstimateMasterModal,
    displayItemNumber,
    handleDisplayItemNumberChange,
    redirectToOtherDocuments
  } = props;

  const userTenantData = useRecoilValue<TTenant | undefined>(userTenant);
  // ユーザーidの取得
  const [userId, setUserId] = useRecoilState<number>(userIdState);
  const [loggedIn, setLoggedIn] = useRecoilState(isLoggedIn);
  const changeLoggedInData = useCallback(
    (newData: string) => setLoggedIn(newData),
    [setLoggedIn]
  );
  const [mainColor] = useRecoilState(mainBlueColor);
  const [buttonColor] = useRecoilState(btnColor);
  const history = useHistory();

  // 単位マスタデータ
  const [mUnitsData, setMUnitsData] = useState([]);

  // 項目行幅
  const [tableSized, setTableSized] = useState<number>(100);
  //「見積書マスタから追加」と「大項目を追加」の表示・非表示制御
  const [addRowButton, setAddRowButton] = useState<boolean>(true);

  // 階層モードのインデックス格納用
  const [viewingItemIndexes, setViewingItemIndexes] = useState<number[]>([]);
  // 階層モード、表示する階層番号
  const [viewingLayer, setViewingLayer] = useState<number>(1);
  // 階層モードのパンくずリスト
  const [breadcrumbs, setBreadcrumbs] = useState<string[]>([]);
  // 粗利率一律設定
  const [uniformGrossProfitMargin, setUniformGrossProfitMargin] =
    useState<number>(0);

  // 全体モード推奨項目を超えているかどうかの判定
  const [itemCountOverFlg, setItemCountOverFlg] = useState<boolean>(false);

  // 別書類作成用に選択された項目
  const [selectedForOtherDocuments, setSelectedForOtherDocuments] =
    useState<TSelectedForOtherDocuments>({});
  // 全選択
  const [allSelectedForOtherDocuments, setAllSelectedForOtherDocuments] =
    useState<boolean>(false);

  // AI単価ポップアップの表示フラグ
  const [showAiPricePopup, setShowAiPricePopup] = useState<boolean>(false);
  // AI単価ポップアップの表示場所指定
  const [priceAnchorEl, setPriceAnchorEl] = useState<HTMLElement | null>(null);
  const [isAiPriceLoading, setIsAiPriceLoading] = useState<boolean>(false);
  const [averagePriceList, setAveragePriceList] = useState<TAiAverageItem>({
    estimate_item_cat: '',
    estimate_sub_cat: '',
    average_price: 'データなし'
  });

  const matches2 = useMediaQuery('(min-width:900px)');
  const classes = useStyles({ matches2, tableSized, mainColor });

  /**
   * ビューモードの切り替え
   */
  const handleChangeViewMode = (event: React.ChangeEvent<HTMLInputElement>) => {
    const mode = (event.target as HTMLInputElement).value as TViewMode;
    saveUserEditEstimateMode(mode);
    // 全体モードの推奨項目数を超えて全体モードに切り替える場合
    if (mode === '全体モード' && itemCountOverFlg) {
      setChangeModeAlertModal(true);
    } else {
      setViewMode(mode);
    }
  };

  // ローカルストレージにユーザーの選択したビューモードを保存する
  const saveUserEditEstimateMode = (mode: string) => {
    const editEstimateMode = getUserEditEstimateMode();
    editEstimateMode[`editEstimateMode:${userId}`] = mode;
    localStorage.setItem('editEstimateMode', JSON.stringify(editEstimateMode));
  };

  // ローカルストレージに保存されているユーザーのビューモードを取得
  const getUserEditEstimateMode = () => {
    const editEstimateModeRaw = localStorage.getItem('editEstimateMode');
    return editEstimateModeRaw ? JSON.parse(editEstimateModeRaw) : {};
  };

  /**
   * 階層モードのパンクズリストからの移動
   *
   * @param destinationLayer // 移動先の階層
   */
  const changeLayer = (destinationLayer: number) => {
    setViewingItemIndexes(prev => prev.slice(0, destinationLayer - 1));
    if (destinationLayer === 1) {
      setBreadcrumbs([]);
    } else {
      let copyBreadcrumbs = [...breadcrumbs];
      copyBreadcrumbs = copyBreadcrumbs.splice(0, destinationLayer - 1);
      setBreadcrumbs(copyBreadcrumbs);
    }
    setViewingLayer(destinationLayer);
  };

  /**
   * パンクズ追加（階層モード）
   * @param itemName // 項目のに入力された文字列
   */
  const addBreadcrumbs = (itemName: string) => {
    let copyBreadcrumbs = [...breadcrumbs];
    copyBreadcrumbs.push(itemName);
    setBreadcrumbs(copyBreadcrumbs);
  };

  /**
   * 階層モードの明細ボタン押下
   */
  const switchingDetailLayer = (
    layer: number,
    index: number,
    itemName: string
  ) => {
    let copyItemList = [...estimateItemList];
    let nextLayerItems = getChildrenByIndexes(copyItemList, [
      ...viewingItemIndexes,
      index
    ]);
    // 下の階層がない場合はデフォルトで階層を作成する
    if (nextLayerItems.length === 0) {
      const newItems = createDefaultEstimateItems(
        layer,
        userTenantData?.estimate_default_items ? ESTIMATE_DEFAULT_ITEM_COUNT : 1
      );
      newItems.forEach(item => nextLayerItems.push(item));
      setEstimateItemList(copyItemList);
    }
    setViewingItemIndexes(prev => [...prev, index]);
    addBreadcrumbs(itemName);
    setViewingLayer(layer);
  };

  /**
   * 別書類作成用にチェックされている見積書項目を取得。
   * withMajorItemsとwithMiddleItemsが両方ともfalseの場合、末端の項目のみを取得
   *
   * @param estimateItems 見積書項目のリスト
   * @param selectedItems 選択項目を表すオブジェクト
   * @param withMajorItems 大項目を含めるかどうか
   * @param withMiddleItems 中間項目を含めるかどうか。ここがtrueの場合、withMajorItemsの値に関わらず大項目も含まれる
   * @returns 選択されている見積書項目のうち、末端の項目のリスト
   */
  function getCheckedItemsForOtherDocuments(
    estimateItems: TEstimateItem[],
    selectedItems: TSelectedForOtherDocuments,
    withMajorItems: boolean,
    withMiddleItems: boolean
  ): TEstimateItem[] {
    type THelper = (
      estimateItem: TEstimateItem,
      selectedItem: TSelectedForOtherDocuments
    ) => TEstimateItem[];

    // 自身の見積書項目と子階層の選択項目を結合するヘルパー関数
    const getWithSelf = (
      estimateItem: TEstimateItem,
      child: TSelectedForOtherDocuments,
      helper: THelper
    ) => {
      return [
        estimateItem,
        Object.keys(child).length > 0 ? helper(estimateItem, child) : []
      ].flat();
    };

    // 1つの見積書項目とその子階層の選択項目を受け取り、選択されている項目を再帰的に取得するヘルパー関数
    const helper: THelper = (estimateItem, selectedItem) => {
      if (Object.keys(selectedItem).length === 0) {
        return [estimateItem];
      }
      const childEstimateItemsMap = new Map(
        estimateItem.childItems.map(item => [String(item.id), item])
      );
      return Object.entries(selectedItem).flatMap(([id, child]) => {
        const childItem = childEstimateItemsMap.get(id) as TEstimateItem;
        return withMiddleItems
          ? getWithSelf(childItem, child, helper)
          : helper(childItem, child);
      });
    };

    // 各大項目に対してヘルパー関数を適用し、全ての選択項目を取得
    const estimateItemsMap = new Map(
      estimateItems.map(item => [String(item.id), item])
    );

    // 末端項目のリストを取得
    const items = Object.entries(selectedItems).flatMap(([id, child]) => {
      const estimateItem = estimateItemsMap.get(id) as TEstimateItem;
      return withMajorItems || withMiddleItems
        ? getWithSelf(estimateItem, child, helper)
        : helper(estimateItem, child);
    });

    // 数量が0で他の項目も未入力のものを除外
    return items.filter(item => {
      // 数量が0または未入力かチェック
      const isZeroQuantity = !item.quantity || item.quantity === 0;
      // 他の項目も未入力かチェック
      const isEmpty =
        (!item.name || item.name === '') &&
        (!item.spec || item.spec === '') &&
        (!item.unitId || item.unitId === 0) &&
        (!item.sellingUnitPrice || item.sellingUnitPrice === 0) &&
        (!item.costUnitPrice || item.costUnitPrice === 0) &&
        (!item.remarks || item.remarks === '');

      // 数量が0かつ他も空なら除外
      return !(isZeroQuantity && isEmpty);
    });
  }

  /**
   * 別書類作成時チェックボックス選択
   * @param indexes 選択された見積書項目に到達するまでのインデックス
   */
  const handleCheckForOtherDocuments = useCallback(
    (indexes: readonly number[]) => {
      let estimateItems = getEstimateItemsByIndexes(estimateItemList, indexes);
      const ids = estimateItems.map(item => item.id);
      let updated = { ...selectedForOtherDocuments };
      let current = updated;
      ids.forEach(id => {
        if (!current[id]) {
          current[id] = {};
        }
        current = current[id] as TSelectedForOtherDocuments;
      });
      // 選択項目が子項目を持っている場合、それ以下の項目を再帰的にすべて選択
      estimateItems[estimateItems.length - 1].childItems.forEach(child => {
        current[child.id] = checkChildren(child);
      });
      setSelectedForOtherDocuments(updated);
      // 現在の階層が全てチェックされていて、かつ第一階層が全て選択されたら、全選択ボタンをONにする
      // 現在階層の選択項目
      let sameLayerSelected = ids
        .slice(0, -1)
        .reduce((acc, id) => acc[id], updated);
      // 現在階層の見積書項目
      let sameLayerEstimateItems = getChildrenByIndexes(
        estimateItemList,
        indexes.slice(0, -1)
      );
      setAllSelectedForOtherDocuments(
        Object.keys(sameLayerSelected).length ===
          sameLayerEstimateItems.length &&
          Object.keys(updated).length > 0 &&
          Object.keys(updated).length === estimateItemList.length
      );
    },
    [selectedForOtherDocuments, estimateItemList]
  );

  /**
   * 別書類作成時チェックボックス選択解除
   * @param indexes 選択解除された見積書項目に到達するまでのインデックス
   */
  const handleUnCheckForOtherDocuments = useCallback(
    (indexes: readonly number[]) => {
      let estimateItems = getEstimateItemsByIndexes(estimateItemList, indexes);
      const ids = estimateItems.map(item => item.id);
      setSelectedForOtherDocuments(prev => {
        let updated = { ...prev };
        let current = updated;
        ids.slice(0, -1).forEach(id => {
          current = current[id];
        });
        const lastId = ids[ids.length - 1];
        delete current[lastId];
        return unCheckParents(updated, ids.slice(0, -1));
      });
      // 全選択ボタン解除
      setAllSelectedForOtherDocuments(false);
    },
    [selectedForOtherDocuments, estimateItemList]
  );

  // 子階層を再起的に選択
  const checkChildren = (
    estimateItem: TEstimateItem
  ): TSelectedForOtherDocuments => {
    if (estimateItem.childItems.length === 0) {
      return {};
    }
    let selectedItems: TSelectedForOtherDocuments = {};
    estimateItem.childItems.forEach(child => {
      selectedItems[child.id] = checkChildren(child);
    });
    return selectedItems;
  };

  // 親階層を再起的に選択解除
  const unCheckParents = (
    selectedItems: TSelectedForOtherDocuments,
    ids: string[]
  ): TSelectedForOtherDocuments => {
    if (ids.length === 0) {
      return selectedItems;
    }
    let current = selectedItems;
    ids.slice(0, -1).forEach(id => {
      current = current[id];
    });
    const lastId = ids[ids.length - 1];
    if (Object.keys(current[lastId]).length === 0) {
      // 子階層の項目が全て選択解除された場合、親項目も選択解除
      delete current[lastId];
      return unCheckParents(selectedItems, ids.slice(0, -1));
    } else {
      return selectedItems;
    }
  };

  /**
   * 項目が別書類作成用にチェックされているかどうか
   */
  const isSelectedForOtherDocuments = useCallback(
    (indexes: readonly number[]): boolean => {
      let estimateItems = getEstimateItemsByIndexes(estimateItemList, indexes);
      const ids = estimateItems.map(item => item.id);
      let current = selectedForOtherDocuments;
      for (let i = 0; i < ids.length; i++) {
        if (!current[ids[i]]) {
          return false;
        }
        current = current[ids[i]];
      }
      return true;
    },
    [selectedForOtherDocuments, estimateItemList]
  );

  // 別書類作成用の全選択
  const handleCheckAllForOtherDocuments = useCallback(
    (event: React.ChangeEvent<HTMLInputElement>) => {
      if (!event.target.checked) {
        setSelectedForOtherDocuments({});
        setAllSelectedForOtherDocuments(false);
      } else {
        setSelectedForOtherDocuments(
          estimateItemList.reduce((acc, item) => {
            acc[item.id] = checkChildren(item);
            return acc;
          }, {} as TSelectedForOtherDocuments)
        );
        setAllSelectedForOtherDocuments(true);
      }
    },
    [selectedForOtherDocuments, estimateItemList]
  );

  const validateOrderItemsList = (
    orderItemList: any[],
    checkUnitPrice: boolean
  ) => {
    for (let i = 0; i < orderItemList.length; i++) {
      if (
        orderItemList[i].costQuantity === 0 ||
        (checkUnitPrice && orderItemList[i].costUnitPrice === 0)
      ) {
        handleError(
          checkUnitPrice
            ? '原価金額が0円の項目があります。'
            : '数量が0の項目があります。'
        );
        return false;
      }
    }
    return true;
  };

  /**
   * 商品発注書作成
   */
  const RedirectToMerchandise = useCallback(
    (isCheckboxChecked: boolean, estimateId: number) => {
      // 選択した項目の大項目と明細階層だけを取得
      const orderItemList = getCheckedItemsForOtherDocuments(
        estimateItemList,
        selectedForOtherDocuments,
        isCheckboxChecked,
        false
      );
      if (orderItemList.length === 0) {
        handleError('項目が取得できませんでした');
        return;
      }
      if (!validateOrderItemsList(orderItemList, false)) return;
      history.replace(`/merchandise-orders/create`, {
        estimateId,
        constructId: estimateInfo.constructId,
        creator: estimateInfo.createUserId,
        estimateItems: orderItemList
      });
    },
    [
      estimateItemList,
      selectedForOtherDocuments,
      estimateInfo,
      history,
      handleError
    ]
  );

  const onClickMerchandise = useCallback(
    (isCheckboxChecked: boolean) =>
      redirectToOtherDocuments(estimateId =>
        RedirectToMerchandise(isCheckboxChecked, estimateId)
      ),
    [RedirectToMerchandise, setSaveConfirmModalState, redirectToOtherDocuments]
  );

  /**
   * 外注発注書作成
   */
  const RedirectToOutsource = useCallback(
    (isCheckboxChecked: boolean, estimateId: number) => {
      // 選択した項目の大項目と明細階層だけを取得
      const orderItemList = getCheckedItemsForOtherDocuments(
        estimateItemList,
        selectedForOtherDocuments,
        isCheckboxChecked,
        false
      );
      if (orderItemList.length === 0) {
        handleError('項目が取得できませんでした');
        return;
      }

      if (!validateOrderItemsList(orderItemList, false)) return;

      for (let i = 0; i < orderItemList.length; i++) {
        if (orderItemList[i].costQuantity === 0) {
          handleError('正しい数量を入力してください。');
          return;
        }
      }

      history.replace(`/outsource-orders/create`, {
        estimateId,
        constructId: estimateInfo.constructId,
        creator: estimateInfo.createUserId,
        estimateItems: orderItemList
      });
    },
    [
      estimateItemList,
      selectedForOtherDocuments,
      estimateInfo,
      history,
      handleError
    ]
  );

  const onClickOutsource = useCallback(
    (isCheckboxChecked: boolean) =>
      redirectToOtherDocuments(estimateId =>
        RedirectToOutsource(isCheckboxChecked, estimateId)
      ),
    [RedirectToOutsource, setSaveConfirmModalState]
  );

  /**
   * 現場連絡表作成
   */
  const RedirectToSiteContact = useCallback(
    (estimateId: number) => {
      // 選択した項目を取得
      const orderItemList = getCheckedItemsForOtherDocuments(
        estimateItemList,
        selectedForOtherDocuments,
        true,
        true
      );
      history.replace(`/site-contacts/create`, {
        //工事番号
        estimateId,
        constructId: estimateInfo.constructId,
        creator: estimateInfo.createUserId,
        salesUser: estimateInfo.salesUserId,
        clientName: estimateInfo.clientName,
        clientChargeName: estimateInfo.clientChargeName,
        estimateItems: orderItemList
      });
    },
    [estimateItemList, selectedForOtherDocuments, estimateInfo, history]
  );

  const onClickSiteContact = useCallback(
    () =>
      redirectToOtherDocuments(estimateId => RedirectToSiteContact(estimateId)),
    [RedirectToSiteContact, setSaveConfirmModalState]
  );

  /**
   * 見積書マスタ作成
   */
  const RegisterQuotation = () => {
    let newItemList: TEstimateItem[] = [];
    estimateItemList.forEach(item => {
      Object.keys(selectedForOtherDocuments).forEach(i => {
        if (i === String(item.id)) {
          newItemList.push(item);
        }
      });
    });
    const layers = [
      'second_items',
      'third_items',
      'fourth_items',
      'fifth_items'
    ];
    function getEstimateMasterObj(items: TEstimateItem[], layer: number): any {
      if (items.length === 0) {
        return [];
      }
      return items.map(item => {
        let obj: any = {
          name: item.name,
          spec: item.spec,
          order_id: -1,
          quantity: item.quantity
            ? item.quantity
            : item.quantity === 0
            ? 0
            : null,
          unit_id: item.unitId,
          selling_unit_price: Number(item.sellingUnitPrice),
          cost_unit_price: Number(item.costUnitPrice),
          cost_quantity: item.costQuantity
            ? item.costQuantity
            : item.costQuantity === 0
            ? 0
            : null,
          cost_unit_id: item.costUnitId,
          layer: item.layer,
          has_under_layer_flg: item.hasUnderLayerFlg,
          all_selling_price: item.allSellingPrice,
          all_cost_price: item.allCostPrice,
          gross_profit: item.grossProfit,
          gross_profit_margin: item.grossProfitMargin,
          remarks: item.remarks,
          author_memo: item.author_memo
        };
        if (layer < 5) {
          obj[layers[layer - 1]] = getEstimateMasterObj(
            item.childItems,
            layer + 1
          );
        }
        return obj;
      });
    }

    if (newItemList.length > 0) {
      setProgressFlg(true);
      registerquotation(getEstimateMasterObj(newItemList, 1)).then(data => {
        setProgressFlg(false);
        if (data === 'Not logged in!') {
          changeLoggedInData('Not logged in!');
        } else {
          if (typeof data === 'string') {
            handleError(data);
          } else {
            if (data.error) {
              handleError(data.error);
            } else {
              handleSuccess(data.message);
            }
          }
        }
      });
    } else {
      handleError('見積もり項目を選択してください。');
    }
  };

  /**
   * 単位マスタ取得
   */
  const getListOfMUnits = useCallback(() => {
    getUnitMasterList().then(data => {
      if (data === 'Not logged in!') {
        changeLoggedInData('Not logged in!');
      } else {
        if (typeof data === 'string') {
          handleError(data);
        } else {
          if (data.error) {
            handleError(data.error);
          } else {
            setMUnitsData(data.data);
          }
        }
      }
    });
  }, [changeLoggedInData]);

  /**
   * 明細の更新
   */
  const updateEstimateItemList: TUpdateEstimateItemList = (
    keyValue,
    indexes
  ) => {
    const { key, value } = keyValue;
    let copyData = [...estimateItemList];

    const parentIndexes = indexes.slice(0, -1);
    let updating = getEstimateItemByIndexes(copyData, indexes);
    let previous = { ...updating };

    // 明細有無変更(再計算無し)
    if (key == 'hasUnderLayerFlg') {
      updating.hasUnderLayerFlg = value;
      if (!previous.hasUnderLayerFlg && previous.quantity === '') {
        updating.quantity = 1;
        updating.costQuantity = 1;
      }
      setEstimateItemList(copyData);
      return;
    }

    // 単位(再計算無し)
    if (key === 'unit') {
      updating.unitId = value.id;
      updating.unitName = value.name;
      //「単価・数量が原価単価・原価数量と同じ」場合、原価単価も同時に変更する
      if (
        previous.quantity === previous.costQuantity &&
        previous.unitId === previous.costUnitId
      ) {
        updating.costUnitId = value.id;
        updating.costUnitName = value.name;
      }
      setEstimateItemList(copyData);
      return;
    }

    // 原価単位(再計算無し)
    if (key === 'costUnit') {
      updating.costUnitId = value.id;
      updating.costUnitName = value.name;
      setEstimateItemList(copyData);
      return;
    }

    // 名称・仕様・備考(再計算無し)
    if (
      key === 'name' ||
      key === 'spec' ||
      key === 'remarks' ||
      key === 'author_memo'
    ) {
      updating[key] = value;
      setEstimateItemList(copyData);
      return;
    }

    // 数量・原価数量
    if (key === 'quantity' || key == 'costQuantity') {
      updating[key] = value;
      //「単価・数量が原価単価・原価数量と同じ」場合、原価数量も同時に変更する
      if (
        previous.quantity === previous.costQuantity &&
        previous.unitId === previous.costUnitId
      ) {
        updating.costQuantity = value;
      }
    }

    // 単価・原価単価
    if (key === 'sellingUnitPrice' || key === 'costUnitPrice') {
      updating[key] = value;
    }

    const quantity = updating.quantity;
    const costQuantity = updating.costQuantity;

    // 粗利率(計算方法が異なる)
    if (key === 'grossProfitMargin') {
      updating.grossProfitMargin = value;
      // 数量が0または空欄の場合は計算が成立しないため処理をしない
      if (!Boolean(quantity)) {
        return;
      }

      // 粗利率100%の場合、原価金額を見積金額に代入、原価金額を0にする
      if (value === 100) {
        setGrossProfitMarginTo100(updating);
      } else {
        // 粗利率100%の以外の場合は、見積金額を算出
        updateSellingPricesFromGrossProfitMargin(updating);
      }
    } else {
      // 見積金額の更新
      const allSellingPriceLocal = calcAllSellingPrice(
        Number(updating.quantity),
        Number(updating.sellingUnitPrice)
      );
      updating.allSellingPrice = allSellingPriceLocal;
      // 原価金額の更新
      const allCostPriceLocal: number = calcAllCostPrice(
        Number(costQuantity),
        Number(updating.costUnitPrice)
      );
      updating.allCostPrice = allCostPriceLocal;
      updating.grossProfitMargin = calcGrossProfitMargin(
        allSellingPriceLocal,
        allCostPriceLocal
      );
    }
    updating.grossProfit = calcGrossProfit(
      updating.allSellingPrice,
      updating.allCostPrice
    );

    // 親階層の再計算
    updateParentsNumericalValues(copyData, parentIndexes);
    setEstimateItemList(copyData);
  };

  /**
   * 項目追加
   */
  const addNewEstimateItem = (layer: number, indexes: number[]) => {
    let copyItemList = [...estimateItemList];
    let newItem: any = createDefaultEstimateItems(layer, 1)[0];
    newItem.id = uuidv4();
    newItem.layer = layer;

    // 現在の見積書の項目数が最大項目数に達しているか確認
    if (itemTotalCount >= ESTIMATE_TOTAL_ITEM_MAX) {
      handleError(
        `${ESTIMATE_TOTAL_ITEM_MAX}項目以上の見積書は作成できません。`
      );
    } else {
      getChildrenByIndexes(copyItemList, indexes).push(newItem);
      setEstimateItemList(copyItemList);
    }
  };

  /**
   * 項目削除
   */
  const deleteEstimateItem: TDeleteEstimateItem = (
    indexes,
    handleUnCheckEstimateItem
  ) => {
    let copyData = [...estimateItemList];
    const parentIndexes = indexes.slice(0, -1);
    if (isSelectedForOtherDocuments(indexes)) {
      handleUnCheckEstimateItem(indexes);
    }
    let sameLayerItems = copyData;
    if (parentIndexes.length > 0) {
      sameLayerItems = getEstimateItemByIndexes(
        copyData,
        parentIndexes
      ).childItems;
    }
    sameLayerItems.splice(indexes.at(-1)!, 1);
    // 親階層の再計算
    updateParentsNumericalValues(copyData, parentIndexes);
    setEstimateItemList(copyData);
  };

  /**
   * 項目コピー
   */
  const copyEstimateItem = (
    indexes: number[],
    items: TEstimateItem[],
    allCopy: boolean
  ) => {
    const newItems = items.map(item => {
      // コピーする項目のidをユニークなものに更新する(uuid4)
      item = updateCopyItemIds(item);
      // 階層を更新
      item = updateEstimateItemLayer(item, indexes.length);

      // 下の階層の階層をコピーしない場合は、childItemsを空にする
      if (!allCopy) {
        item.hasUnderLayerFlg = false;
        item.childItems.length = 0;
      }
      return item;
    });

    let copyData = [...estimateItemList];
    let parentIndexes = indexes.slice(0, -1);
    let layerIndex = indexes.at(-1)!;
    if (parentIndexes.length === 0) {
      // 第一階層へのコピー
      copyData.splice(layerIndex, 0, ...newItems);
      setEstimateItemList(copyData);
    } else {
      let parentItem = getEstimateItemByIndexes(copyData, parentIndexes);
      parentItem.hasUnderLayerFlg = true;
      parentItem.childItems.splice(layerIndex, 0, ...newItems);
      updateParentsNumericalValues(copyData, parentIndexes);
      setEstimateItemList(copyData);
    }
  };

  /**
   * 粗利一律設定
   */
  const updateUniformGrossProfitMargin: TSetUniformGrossProfitMargin = (
    value,
    indexes
  ) => {
    let copyData = [...estimateItemList];
    let parentItem = getEstimateItemByIndexes(copyData, indexes);
    parentItem.childItems.forEach((item: any) => {
      // 数量が0または空欄の場合は計算が成立しないため処理をしない
      if (!Boolean(item.quantity)) {
        return;
      } else {
        if (!item.hasUnderLayerFlg) {
          item.grossProfitMargin = value;
          // 粗利率100%の場合、原価金額を見積金額に代入、原価単価,原価金額を0にする
          if (value === 100) {
            setGrossProfitMarginTo100(item);
          } else {
            // 粗利率100%の以外の場合は、見積金額を算出
            updateSellingPricesFromGrossProfitMargin(item);
          }
        }
      }
    });
    updateParentsNumericalValues(copyData, indexes);
    setEstimateItemList(copyData);
  };

  /**
   * ドラッグアンドドロップ
   * @param result
   * @returns
   *
   * result.source.index ->出発点のindex
   * result.destination.index ->着地点のindex
   * reorder関数 -> 配列と上記のインデックスを渡し、配列のインデックスを入れ替えて返す
   */
  function onDragEnd(result: any) {
    if (!result.destination) {
      return;
    }

    if (result.destination.index === result.source.index) {
      return;
    }

    let copyData = [...estimateItemList];
    let sameLayerItems =
      viewMode === '階層モード'
        ? getChildrenByIndexes(copyData, viewingItemIndexes)
        : copyData;
    const arrangedItem = reorder(
      sameLayerItems,
      result.source.index,
      result.destination.index
    ) as TEstimateItem[];
    sameLayerItems.length = 0; // 元の配列をクリア
    sameLayerItems.push(...arrangedItem); // 新しい内容を追加
    setEstimateItemList(copyData);
  }

  const handleAiPricePopupClose = () => {
    setShowAiPricePopup(false);
    setPriceAnchorEl(null);
  };

  /**
   * 平均単価取得
   */
  const getListOfAiEstimatePrice = (
    estimateMainItem: string,
    estimateSubItem: string
  ) => {
    setIsAiPriceLoading(true);
    const AveragePriceList = sessionStorage.getItem(
      estimateMainItem + estimateSubItem
    );
    if (AveragePriceList) {
      setAveragePriceList(JSON.parse(AveragePriceList));
      setIsAiPriceLoading(false);
    } else {
      getAiEstimatePriceAverage(estimateMainItem, estimateSubItem).then(
        data => {
          if (data === 'Not logged in!') {
            changeLoggedInData('Not logged in!');
          } else {
            if (typeof data === 'string') {
              handleError(data);
            } else {
              if (data.error) {
                handleError(data.error);
              } else {
                setAveragePriceList(data);
                setIsAiPriceLoading(false);
                sessionStorage.setItem(
                  estimateMainItem + estimateSubItem,
                  JSON.stringify(data)
                );
                // レスポンスデータが'データなし'の場合はポップアップを閉じる
                if (typeof data.average_price === 'string') {
                  setShowAiPricePopup(false);
                }
              }
            }
          }
        }
      );
    }
  };

  // 単位マスタデータ取得
  useEffect(() => {
    getListOfMUnits();
  }, []);

  // ページ読み込み時にローカルストレージから現在のユーザーの選択されたモードを取得して設定
  useEffect(() => {
    const editEstimateMode = getUserEditEstimateMode();
    const savedEditEstimateMode =
      editEstimateMode[`editEstimateMode:${userId}`];
    if (savedEditEstimateMode) {
      setViewMode(savedEditEstimateMode);
    }
  }, [userId]);

  // ビューモードが変更された際の処理
  useEffect(() => {
    // 階層モードを第一階層に戻す
    setViewingLayer(1);
    // 階層モードの選択されたインデックスを初期化
    setViewingItemIndexes([]);
    // 階層モードのパンくずを初期化
    setBreadcrumbs([]);
  }, [viewMode]);

  // 項目リストが更新された際
  useEffect(() => {
    if (estimateItemList.length >= ESTIMATE_ITEM_MAX) {
      // 「見積書マスタから追加」と「大項目追加」を非表示
      setAddRowButton(false);
    } else {
      // 「見積書マスタから追加」と「大項目追加」を表示
      setAddRowButton(true);
    }

    setCustomFormatOverLayerFlg(false);
    let itemCount = estimateItemList.length;

    // 項目数のカウント
    estimateItemList.map(item => {
      if (item.hasUnderLayerFlg && item.childItems.length > 0) {
        item.childItems.map(secondItem => {
          itemCount++;
          if (secondItem.hasUnderLayerFlg) {
            // ２階層に明細ありの項目がある場合はフラグ切り替え
            setCustomFormatOverLayerFlg(true);
            if (
              secondItem.hasUnderLayerFlg &&
              secondItem.childItems.length > 0
            ) {
              secondItem.childItems.map(thirdItem => {
                itemCount++;
                if (
                  thirdItem.hasUnderLayerFlg &&
                  thirdItem.childItems.length > 0
                ) {
                  thirdItem.childItems.map(fourthItem => {
                    itemCount++;
                    if (
                      fourthItem.hasUnderLayerFlg &&
                      fourthItem.childItems.length > 0
                    ) {
                      itemCount += fourthItem.childItems.length;
                    }
                  });
                }
              });
            }
          }
        });
      }
    });

    // 項目数が全体モード推奨数に達しているかどうか判定
    if (itemCount >= ESTIMATE_ALLVIEW_MODE_ITEM_MAX) {
      // 全体モード利用時に推奨数を超えた場合はモーダル表示
      if (itemCountOverFlg === false && viewMode === '全体モード') {
        setChangeModeAlertModal(true);
      }
      setItemCountOverFlg(true);
    } else {
      setItemCountOverFlg(false);
    }
    setItemTotalCount(itemCount);
  }, [estimateItemList]);

  // コピーモーダルによるコピー処理
  useEffect(() => {
    if (copyModalState.type === 'submitted') {
      let indexes = copyModalState.copyTo.location.map(item => item.index);
      let sameLayerItems = getChildrenByIndexes(estimateItemList, indexes);
      indexes = indexes.concat(sameLayerItems.length);
      copyEstimateItem(
        indexes,
        [copyModalState.copyItem],
        copyModalState.allCopy
      );
      copyModalDispatch({ type: 'close' });
    }
  }, [copyModalState]);

  return (
    <>
      <div
        style={{
          display: 'flex',
          justifyContent: 'space-between',
          padding: '10px 0px',
          alignItems: 'center'
        }}
      >
        <div
          style={{
            display: 'flex',
            flexDirection: 'column',
            alignContent: 'space-between'
          }}
        >
          <div style={{ display: 'flex', flexDirection: 'row', marginTop: 20 }}>
            <FormControl component='fieldset'>
              <RadioGroup
                row
                aria-label='position'
                name='position'
                value={viewMode}
                onChange={handleChangeViewMode}
              >
                <FormControlLabel
                  value='階層モード'
                  control={<Radio color='primary' />}
                  label='階層モード'
                  labelPlacement='end'
                />
                <FormControlLabel
                  value='全体モード'
                  control={<Radio color='primary' />}
                  label='全体モード'
                  labelPlacement='end'
                />
              </RadioGroup>
              <div
                style={{ display: 'flex', alignItems: 'center', marginTop: 8 }}
              >
                <Checkbox
                  checked={displayItemNumber}
                  color='default'
                  style={{ marginRight: 16 }}
                  onChange={handleDisplayItemNumberChange}
                />
                項目No.をPDFに表示する
              </div>
            </FormControl>
          </div>
        </div>

        <div
          style={{
            display: 'flex',
            justifyContent: 'flex-start',
            alignItems: 'center',
            marginRight: 20
          }}
        >
          {viewingLayer === 1 && (
            <div style={{ marginRight: 16 }}>
              <OtherDocumentCreationButtons
                isDisabled={Object.keys(selectedForOtherDocuments).length === 0}
                onClickMerchandise={onClickMerchandise}
                onClickOutsource={onClickOutsource}
                onClickSiteContact={onClickSiteContact}
                RegisterQuotation={RegisterQuotation}
              />
            </div>
          )}
          {viewingLayer !== 1 && (
            <div
              style={{
                display: 'flex',
                justifyContent: 'flex-start',
                alignItems: 'center',
                padding: '10px 0px',
                marginRight: 64
              }}
            >
              <div style={{ marginLeft: 40 }}>粗利率一律設定</div>
              <div style={{ marginLeft: 20 }}>
                <input
                  value={uniformGrossProfitMargin}
                  type='number'
                  min='0'
                  onChange={text => {
                    setUniformGrossProfitMargin(Number(text.target.value));
                  }}
                  className={classes.smallInput}
                  onWheel={(e: any) => e.target.blur()}
                />
              </div>
              <div style={{ marginLeft: 10 }}>%</div>
              <div style={{ marginLeft: 20 }}>
                <Button
                  style={{ color: '#758283', backgroundColor: '#F5F5F5' }}
                  variant='contained'
                  onClick={() =>
                    updateUniformGrossProfitMargin(
                      uniformGrossProfitMargin,
                      viewingItemIndexes
                    )
                  }
                >
                  設定
                </Button>
              </div>
            </div>
          )}
          <div
            style={{
              marginRight: 10,
              fontSize: 16,
              justifyContent: 'center',
              alignItems: 'center',
              display: 'flex'
            }}
          >
            項目行幅
          </div>
          <div style={{ width: 100, marginLeft: 20 }}>
            <select
              defaultValue={tableSized}
              onChange={e => {
                setTableSized(Number(e.target.value));
              }}
              className={classes.selectBoxStyle}
              name='cars'
              id='cars'
              form='carform'
            >
              <option value={0}>小</option>
              <option value={50}>中</option>
              <option value={100}>大</option>
            </select>
          </div>
        </div>
      </div>
      {viewingLayer == 1 ? ( //階層モードのパンくずリスト
        <div style={{ height: 60 }}></div>
      ) : (
        <div
          style={{
            display: 'flex',
            justifyContent: 'flex-start',
            alignItems: 'center',
            fontSize: 18,
            marginTop: 12,
            marginBottom: 12
          }}
        >
          {breadcrumbs.map((name: string, index: number) => (
            <div
              style={{
                display: 'flex',
                justifyContent: 'flex-start',
                alignItems: 'center'
              }}
            >
              <div
                style={{ cursor: 'pointer', textDecorationLine: 'Underline' }}
                onClick={() => changeLayer(index + 1)}
              >
                {name}
              </div>
              <div style={{ marginLeft: 20, marginRight: 20 }}>
                <NavigateNextIcon />
              </div>
            </div>
          ))}
        </div>
      )}

      {viewMode === '階層モード' && (
        <>
          <TableContainer component={Paper}>
            <Table
              className={classes.main}
              aria-label='customized table'
              style={{ width: 1970 }}
            >
              {/* ヘッダー */}
              <LayerModeTableHead
                layer={viewingLayer}
                isChecked={
                  viewingLayer === 1 ? allSelectedForOtherDocuments : undefined
                }
                onSelectAll={
                  viewingLayer === 1
                    ? handleCheckAllForOtherDocuments
                    : undefined
                }
              />
              <DragDropContext onDragEnd={onDragEnd}>
                <Droppable droppableId='droppable'>
                  {(droppableProvided: DroppableProvided) => (
                    <TableBody
                      ref={droppableProvided.innerRef}
                      {...droppableProvided.droppableProps}
                    >
                      <>
                        {(() => {
                          const viewingItems = getChildrenByIndexes(
                            estimateItemList,
                            viewingItemIndexes
                          );
                          return (
                            <>
                              {viewingItems.map((item: any, index: number) => (
                                <Draggable
                                  draggableId={index.toString()}
                                  index={index}
                                  key={index}
                                >
                                  {provided => (
                                    <>
                                      <EstimateItemRow
                                        provided={provided}
                                        item={item}
                                        indexes={[...viewingItemIndexes, index]}
                                        selected={isSelectedForOtherDocuments([
                                          ...viewingItemIndexes,
                                          index
                                        ])}
                                        estimateItemList={estimateItemList}
                                        classes={classes}
                                        tableSized={tableSized}
                                        mUnitsData={mUnitsData}
                                        viewMode='layer'
                                        handleCheckItem={() =>
                                          handleCheckForOtherDocuments([
                                            ...viewingItemIndexes,
                                            index
                                          ])
                                        }
                                        handleUnCheckItem={() =>
                                          handleUnCheckForOtherDocuments([
                                            ...viewingItemIndexes,
                                            index
                                          ])
                                        }
                                        updateEstimateItemList={
                                          updateEstimateItemList
                                        }
                                        handleDeleteItem={() => {
                                          deleteEstimateItem(
                                            [...viewingItemIndexes, index],
                                            handleUnCheckForOtherDocuments
                                          );
                                        }}
                                        setLocalStorage={setLocalStorage}
                                        switchingDetailLayer={
                                          switchingDetailLayer
                                        }
                                        copyModalDispatch={copyModalDispatch}
                                        showAiPricePopup={showAiPricePopup}
                                        priceAnchorEl={priceAnchorEl}
                                        averagePriceList={averagePriceList}
                                        isAiPriceLoading={isAiPriceLoading}
                                        handleAiPricePopupClose={
                                          handleAiPricePopupClose
                                        }
                                        setPriceAnchorEl={setPriceAnchorEl}
                                        setShowAiPricePopup={
                                          setShowAiPricePopup
                                        }
                                        handleError={handleError}
                                        getListOfAiEstimatePrice={
                                          getListOfAiEstimatePrice
                                        }
                                      />
                                    </>
                                  )}
                                </Draggable>
                              ))}
                              {droppableProvided.placeholder}
                            </>
                          );
                        })()}
                      </>
                    </TableBody>
                  )}
                </Droppable>
              </DragDropContext>
            </Table>
          </TableContainer>
          {/* 階層モード下部ボタン */}
          <div
            style={{
              display: 'flex',
              justifyContent: 'flex-end',
              padding: '10px 0px'
            }}
          >
            {viewingLayer === 1 ? (
              <>
                {addRowButton && (
                  <>
                    <EstimateItemsUnderButton
                      buttonColor={buttonColor}
                      handleClick={() => setOpenImportEstimateMasterModal(true)}
                    >
                      見積書マスタから追加
                    </EstimateItemsUnderButton>
                    <EstimateItemsUnderButton
                      buttonColor={buttonColor}
                      handleClick={() =>
                        addNewEstimateItem(viewingLayer, viewingItemIndexes)
                      }
                    >
                      <LibraryAddIcon />
                      <span style={{ marginLeft: 8 }}>項目を追加</span>
                    </EstimateItemsUnderButton>
                  </>
                )}
              </>
            ) : (
              <>
                {getChildrenByIndexes(estimateItemList, viewingItemIndexes)
                  .length < ESTIMATE_SUB_ITEM_MAX && (
                  <EstimateItemsUnderButton
                    buttonColor={buttonColor}
                    handleClick={() =>
                      addNewEstimateItem(viewingLayer, viewingItemIndexes)
                    }
                  >
                    <LibraryAddIcon />
                    <span style={{ marginLeft: 8 }}>項目を追加</span>
                  </EstimateItemsUnderButton>
                )}
                <EstimateItemsUnderButton
                  buttonColor={buttonColor}
                  handleClick={() => changeLayer(viewingLayer - 1)}
                >
                  上の階層に戻る
                </EstimateItemsUnderButton>
              </>
            )}
          </div>
        </>
      )}
      {/* 全体モード */}
      {viewMode === '全体モード' && (
        <>
          <TableContainer component={Paper} style={{ paddingLeft: '20px' }}>
            <Table
              className={classes.main}
              aria-label='customized table'
              style={{ width: 1960 }}
            >
              {/* ヘッダー */}
              <AllViewModeTableHead />
              {/* 全体モード第一階層 */}
              {/* drag and drop estimate item table rows */}
              <DragDropContext onDragEnd={onDragEnd}>
                <Droppable droppableId='droppable'>
                  {(droppableProvided: DroppableProvided) => (
                    <TableBody
                      ref={droppableProvided.innerRef}
                      {...droppableProvided.droppableProps}
                    >
                      {estimateItemList.length > 0 &&
                        estimateItemList.map((item: any, index: number) => (
                          <>
                            {(index !== 0 ||
                              (estimateItemList[index - 1] &&
                                estimateItemList[index - 1].hasUnderLayerFlg ==
                                  true)) && (
                              <AllViewModeBreadcrumbs
                                layer={item.layer}
                                itemNames={[item.name]}
                                itemLength={estimateItemList.length}
                                addNewEstimateItem={addNewEstimateItem}
                                indexes={[]}
                              />
                            )}
                            <Draggable
                              draggableId={index.toString()}
                              index={index}
                              key={index}
                            >
                              {provided => (
                                <>
                                  <EstimateItemRow
                                    provided={provided}
                                    item={item}
                                    selected={isSelectedForOtherDocuments([
                                      index
                                    ])}
                                    indexes={[index]}
                                    estimateItemList={estimateItemList}
                                    classes={classes}
                                    tableSized={tableSized}
                                    mUnitsData={mUnitsData}
                                    viewMode='all'
                                    handleCheckItem={() =>
                                      handleCheckForOtherDocuments([index])
                                    }
                                    handleUnCheckItem={() =>
                                      handleUnCheckForOtherDocuments([index])
                                    }
                                    updateEstimateItemList={
                                      updateEstimateItemList
                                    }
                                    handleDeleteItem={() => {
                                      deleteEstimateItem(
                                        [index],
                                        handleUnCheckForOtherDocuments
                                      );
                                    }}
                                    setLocalStorage={setLocalStorage}
                                    copyModalDispatch={copyModalDispatch}
                                  />
                                </>
                              )}
                            </Draggable>
                            {/* 全体モード第二階層 */}
                            {item.childItems.length > 0 &&
                              item.childItems.map(
                                (secondItem: any, secondIndex: number) => (
                                  <>
                                    {(secondIndex === 0 ||
                                      item.childItems[secondIndex - 1]
                                        .hasUnderLayerFlg == true) && (
                                      <AllViewModeBreadcrumbs
                                        layer={secondItem.layer}
                                        itemNames={[item.name]}
                                        itemLength={item.childItems.length}
                                        addNewEstimateItem={addNewEstimateItem}
                                        indexes={[index]}
                                      />
                                    )}
                                    <EstimateItemRow
                                      item={secondItem}
                                      selected={isSelectedForOtherDocuments([
                                        index,
                                        secondIndex
                                      ])}
                                      indexes={[index, secondIndex]}
                                      estimateItemList={estimateItemList}
                                      classes={classes}
                                      tableSized={tableSized}
                                      mUnitsData={mUnitsData}
                                      viewMode='all'
                                      handleCheckItem={() =>
                                        handleCheckForOtherDocuments([
                                          index,
                                          secondIndex
                                        ])
                                      }
                                      handleUnCheckItem={() =>
                                        handleUnCheckForOtherDocuments([
                                          index,
                                          secondIndex
                                        ])
                                      }
                                      updateEstimateItemList={
                                        updateEstimateItemList
                                      }
                                      handleDeleteItem={() => {
                                        deleteEstimateItem(
                                          [index, secondIndex],
                                          handleUnCheckForOtherDocuments
                                        );
                                      }}
                                      setLocalStorage={setLocalStorage}
                                      copyModalDispatch={copyModalDispatch}
                                      showAiPricePopup={showAiPricePopup}
                                      priceAnchorEl={priceAnchorEl}
                                      averagePriceList={averagePriceList}
                                      isAiPriceLoading={isAiPriceLoading}
                                      handleAiPricePopupClose={
                                        handleAiPricePopupClose
                                      }
                                      setPriceAnchorEl={setPriceAnchorEl}
                                      setShowAiPricePopup={setShowAiPricePopup}
                                      handleError={handleError}
                                      getListOfAiEstimatePrice={
                                        getListOfAiEstimatePrice
                                      }
                                    />
                                    {/* 全体モード第三階層 */}
                                    {secondItem.childItems.length > 0 &&
                                      secondItem.childItems.map(
                                        (
                                          thirdItem: any,
                                          thirdIndex: number
                                        ) => (
                                          <>
                                            {(thirdIndex === 0 ||
                                              secondItem.childItems[
                                                thirdIndex - 1
                                              ].hasUnderLayerFlg == true) && (
                                              <AllViewModeBreadcrumbs
                                                layer={thirdItem.layer}
                                                itemNames={[
                                                  item.name,
                                                  secondItem.name
                                                ]}
                                                itemLength={
                                                  secondItem.childItems.length
                                                }
                                                addNewEstimateItem={
                                                  addNewEstimateItem
                                                }
                                                indexes={[index, secondIndex]}
                                              />
                                            )}
                                            <EstimateItemRow
                                              item={thirdItem}
                                              selected={isSelectedForOtherDocuments(
                                                [index, secondIndex, thirdIndex]
                                              )}
                                              indexes={[
                                                index,
                                                secondIndex,
                                                thirdIndex
                                              ]}
                                              estimateItemList={
                                                estimateItemList
                                              }
                                              classes={classes}
                                              tableSized={tableSized}
                                              mUnitsData={mUnitsData}
                                              viewMode='all'
                                              handleCheckItem={() =>
                                                handleCheckForOtherDocuments([
                                                  index,
                                                  secondIndex,
                                                  thirdIndex
                                                ])
                                              }
                                              handleUnCheckItem={() =>
                                                handleUnCheckForOtherDocuments([
                                                  index,
                                                  secondIndex,
                                                  thirdIndex
                                                ])
                                              }
                                              updateEstimateItemList={
                                                updateEstimateItemList
                                              }
                                              handleDeleteItem={() => {
                                                deleteEstimateItem(
                                                  [
                                                    index,
                                                    secondIndex,
                                                    thirdIndex
                                                  ],
                                                  handleUnCheckForOtherDocuments
                                                );
                                              }}
                                              setLocalStorage={setLocalStorage}
                                              copyModalDispatch={
                                                copyModalDispatch
                                              }
                                            />
                                            {/* 全体モード第四階層 */}
                                            {thirdItem.childItems.length > 0 &&
                                              thirdItem.childItems.map(
                                                (
                                                  fourthItem: any,
                                                  fourthIndex: number
                                                ) => (
                                                  <>
                                                    {(fourthIndex === 0 ||
                                                      thirdItem.childItems[
                                                        fourthIndex - 1
                                                      ].hasUnderLayerFlg ==
                                                        true) && (
                                                      <AllViewModeBreadcrumbs
                                                        layer={fourthItem.layer}
                                                        itemNames={[
                                                          item.name,
                                                          secondItem.name,
                                                          thirdItem.name
                                                        ]}
                                                        itemLength={
                                                          thirdItem.childItems
                                                            .length
                                                        }
                                                        addNewEstimateItem={
                                                          addNewEstimateItem
                                                        }
                                                        indexes={[
                                                          index,
                                                          secondIndex,
                                                          thirdIndex
                                                        ]}
                                                      />
                                                    )}
                                                    <EstimateItemRow
                                                      item={fourthItem}
                                                      selected={isSelectedForOtherDocuments(
                                                        [
                                                          index,
                                                          secondIndex,
                                                          thirdIndex,
                                                          fourthIndex
                                                        ]
                                                      )}
                                                      indexes={[
                                                        index,
                                                        secondIndex,
                                                        thirdIndex,
                                                        fourthIndex
                                                      ]}
                                                      estimateItemList={
                                                        estimateItemList
                                                      }
                                                      classes={classes}
                                                      tableSized={tableSized}
                                                      mUnitsData={mUnitsData}
                                                      viewMode='all'
                                                      handleCheckItem={() =>
                                                        handleCheckForOtherDocuments(
                                                          [
                                                            index,
                                                            secondIndex,
                                                            thirdIndex,
                                                            fourthIndex
                                                          ]
                                                        )
                                                      }
                                                      handleUnCheckItem={() =>
                                                        handleUnCheckForOtherDocuments(
                                                          [
                                                            index,
                                                            secondIndex,
                                                            thirdIndex,
                                                            fourthIndex
                                                          ]
                                                        )
                                                      }
                                                      updateEstimateItemList={
                                                        updateEstimateItemList
                                                      }
                                                      handleDeleteItem={() => {
                                                        deleteEstimateItem(
                                                          [
                                                            index,
                                                            secondIndex,
                                                            thirdIndex,
                                                            fourthIndex
                                                          ],
                                                          handleUnCheckForOtherDocuments
                                                        );
                                                      }}
                                                      setLocalStorage={
                                                        setLocalStorage
                                                      }
                                                      copyModalDispatch={
                                                        copyModalDispatch
                                                      }
                                                    />
                                                    {/* 全体モード第五階層 */}
                                                    {fourthItem.childItems
                                                      .length > 0 &&
                                                      fourthItem.childItems.map(
                                                        (
                                                          fifthItem: any,
                                                          fifthIndex: number
                                                        ) => (
                                                          <>
                                                            {(fifthIndex ===
                                                              0 ||
                                                              fourthItem
                                                                .childItems[
                                                                fifthIndex - 1
                                                              ]
                                                                .hasUnderLayerFlg ==
                                                                true) && (
                                                              <AllViewModeBreadcrumbs
                                                                layer={
                                                                  fifthItem.layer
                                                                }
                                                                itemNames={[
                                                                  item.name,
                                                                  secondItem.name,
                                                                  thirdItem.name,
                                                                  fourthItem.name
                                                                ]}
                                                                itemLength={
                                                                  fourthItem
                                                                    .childItems
                                                                    .length
                                                                }
                                                                addNewEstimateItem={
                                                                  addNewEstimateItem
                                                                }
                                                                indexes={[
                                                                  index,
                                                                  secondIndex,
                                                                  thirdIndex,
                                                                  fourthIndex
                                                                ]}
                                                              />
                                                            )}
                                                            <EstimateItemRow
                                                              item={fifthItem}
                                                              selected={isSelectedForOtherDocuments(
                                                                [
                                                                  index,
                                                                  secondIndex,
                                                                  thirdIndex,
                                                                  fourthIndex,
                                                                  fifthIndex
                                                                ]
                                                              )}
                                                              indexes={[
                                                                index,
                                                                secondIndex,
                                                                thirdIndex,
                                                                fourthIndex,
                                                                fifthIndex
                                                              ]}
                                                              estimateItemList={
                                                                estimateItemList
                                                              }
                                                              classes={classes}
                                                              tableSized={
                                                                tableSized
                                                              }
                                                              mUnitsData={
                                                                mUnitsData
                                                              }
                                                              viewMode='all'
                                                              handleCheckItem={() =>
                                                                handleCheckForOtherDocuments(
                                                                  [
                                                                    index,
                                                                    secondIndex,
                                                                    thirdIndex,
                                                                    fourthIndex,
                                                                    fifthIndex
                                                                  ]
                                                                )
                                                              }
                                                              handleUnCheckItem={() =>
                                                                handleUnCheckForOtherDocuments(
                                                                  [
                                                                    index,
                                                                    secondIndex,
                                                                    thirdIndex,
                                                                    fourthIndex,
                                                                    fifthIndex
                                                                  ]
                                                                )
                                                              }
                                                              updateEstimateItemList={
                                                                updateEstimateItemList
                                                              }
                                                              handleDeleteItem={() => {
                                                                deleteEstimateItem(
                                                                  [
                                                                    index,
                                                                    secondIndex,
                                                                    thirdIndex,
                                                                    fourthIndex,
                                                                    fifthIndex
                                                                  ],
                                                                  handleUnCheckForOtherDocuments
                                                                );
                                                              }}
                                                              setLocalStorage={
                                                                setLocalStorage
                                                              }
                                                              copyModalDispatch={
                                                                copyModalDispatch
                                                              }
                                                            />
                                                          </>
                                                        )
                                                      )}
                                                    {/* 第五階層追加ボタン */}
                                                    {fourthItem.hasUnderLayerFlg ==
                                                      true &&
                                                      fourthItem.childItems
                                                        .length === 0 && (
                                                        <AddUnderLayerButton
                                                          layer={5}
                                                          indexes={[
                                                            index,
                                                            secondIndex,
                                                            thirdIndex,
                                                            fourthIndex
                                                          ]}
                                                          addNewEstimateItem={
                                                            addNewEstimateItem
                                                          }
                                                        />
                                                      )}
                                                  </>
                                                )
                                              )}
                                            {/* 第四階層追加ボタン */}
                                            {thirdItem.hasUnderLayerFlg ==
                                              true &&
                                              thirdItem.childItems.length ===
                                                0 && (
                                                <AddUnderLayerButton
                                                  layer={4}
                                                  indexes={[
                                                    index,
                                                    secondIndex,
                                                    thirdIndex
                                                  ]}
                                                  addNewEstimateItem={
                                                    addNewEstimateItem
                                                  }
                                                />
                                              )}
                                          </>
                                        )
                                      )}
                                    {/* 第三階層追加ボタン */}
                                    {secondItem.hasUnderLayerFlg == true &&
                                      secondItem.childItems.length === 0 && (
                                        <AddUnderLayerButton
                                          layer={3}
                                          indexes={[index, secondIndex]}
                                          addNewEstimateItem={
                                            addNewEstimateItem
                                          }
                                        />
                                      )}
                                  </>
                                )
                              )}
                            {/* 第二階層追加ボタン */}
                            {item.hasUnderLayerFlg &&
                              item.childItems.length === 0 && (
                                <AddUnderLayerButton
                                  layer={2}
                                  indexes={[index]}
                                  addNewEstimateItem={addNewEstimateItem}
                                />
                              )}
                          </>
                        ))}

                      {droppableProvided.placeholder}
                    </TableBody>
                  )}
                </Droppable>
              </DragDropContext>
            </Table>
          </TableContainer>
          <div
            style={{
              display: 'flex',
              justifyContent: 'flex-end',
              padding: '10px 0px'
            }}
          >
            {addRowButton && (
              <>
                <Button
                  style={{
                    backgroundColor: buttonColor,
                    marginRight: 15
                  }}
                  variant='contained'
                  color='primary'
                  onClick={() => setOpenImportEstimateMasterModal(true)}
                >
                  見積書マスタから追加
                </Button>
                <Button
                  style={{ backgroundColor: buttonColor, marginRight: 15 }}
                  variant='contained'
                  color='primary'
                  onClick={() => {
                    addNewEstimateItem(1, []);
                  }}
                >
                  <LibraryAddIcon />
                  <span style={{ marginLeft: 8 }}>大項目を追加</span>
                </Button>
              </>
            )}
          </div>
        </>
      )}
    </>
  );
};

export default EstimateItems;
